import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private isDarkTheme = false

  constructor() {
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme) {
      this.isDarkTheme = savedTheme === 'dark'
      this.setTheme(this.isDarkTheme)
    }
  }

  toggleTheme() {
    this.isDarkTheme = !this.isDarkTheme
    this.setTheme(this.isDarkTheme)
    localStorage.setItem('theme', this.isDarkTheme ? 'dark' : 'light')
  }

  setTheme(isDark: boolean) {
    requestAnimationFrame(() => {
      document.documentElement.setAttribute(
        'data-theme',
        isDark ? 'dark' : 'light'
      )
      // Update browser theme-color meta tag for iOS/Android toolbars
      const themeColor = isDark ? '#0f172a' : '#ffffff'
      let metaTag = document.querySelector('meta[name="theme-color"]')
      if (metaTag) {
        metaTag.setAttribute('content', themeColor)
      }
    })
  }

  isDarkMode() {
    return this.isDarkTheme
  }
}
